import { render } from "./CartLikeContentDetail.vue?vue&type=template&id=64ee6436"
import script from "./CartLikeContentDetail.js?vue&type=script&lang=js"
export * from "./CartLikeContentDetail.js?vue&type=script&lang=js"

import "./CartLikeContentDetail.scss?vue&type=style&index=0&lang=scss"
/* custom blocks */
import block0 from "./CartLikeContentDetail.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Firshadck%2Fprojects%2Fsunrise-spa%2Fsrc%2Fpresentation%2Ffashion%2FCartDetail%2FCartLikeContentDetail%2FCartLikeContentDetail.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/Users/irshadck/projects/sunrise-spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__